export default __webpack_public_path__ + "static/media/the_hanged_man.bed58ca0.png";